import React from 'react';

const IconReplay = ({ className }) => (
    <svg className={className} width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path stroke="#AFD8DB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M1.91669 2.66666V8.16666H7.41669" />
        <path stroke="#AFD8DB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M4.21752 12.75C4.81188 14.437 5.93841 15.8852 7.42737 16.8763C8.91633 17.8674 10.6871 18.3477 12.4728 18.2449C14.2585 18.1422 15.9624 17.4618 17.3278 16.3064C18.6932 15.1511 19.6462 13.5832 20.0431 11.8392C20.4399 10.0951 20.2593 8.26929 19.5283 6.63684C18.7972 5.00438 17.5555 3.65372 15.9901 2.78836C14.4247 1.923 12.6205 1.58982 10.8493 1.83902C9.0781 2.08822 7.43586 2.9063 6.17002 4.16999L1.91669 8.16666" />
    </svg>
);

export default IconReplay;